import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import { assetIds, RichTextfield, ThemedAsset } from "nemuru-components";
import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { parseStringAmountWithUnitToNumber } from "../../../../../../utils/formaters";
import { ICON_TITLE_HEIGHT } from "../../../../../../config/config";
import { objectTypesConfigToArray } from "../../../../../../utils/objectTypesConfigToArray";
import IconTitle from "../../../../../shared/components/IconTitle";
import InfoPanel from "../../../../../shared/components/InfoPanel";
import MainButton from "../../../../../shared/components/MainButton";
import Text from "../../../../../shared/components/Text";
import {
  infoDataPropertyTypeForm,
  residencePropertyTypesConfig,
  residencePropertyTypesWithoutOthersConfig,
} from "../../config";

export default function AdditionalDataPropertyTypeForm({
  onSubmitForm,
  data,
  disableOthers,
}) {
  const { palette } = useTheme();

  const {
    register,
    clearErrors,
    getValues,
    handleSubmit,
    errors,
    control,
    watch,
  } = useForm({
    defaultValues: {
      propertyType: data?.propertyType || "",
      mortgage: data?.mortgage || false,
    },
    reValidateMode: "onBlur",
  });

  const mortgage = watch("mortgage");

  const validateMinimumMortgageValueAndReturnMessage = (value) => {
    const minimumMortgage = 0;
    const mortgageInt = parseStringAmountWithUnitToNumber(value);
    if (!!mortgage && mortgageInt <= minimumMortgage) {
      return (
        <Text
          tId={"MORTGAGE_AMOUNT_GREATER_THAN_VALUE"}
          dynamicDataTexts={[minimumMortgage]}
        />
      );
    }
  };

  useEffect(() => {
    clearErrors();
  }, [mortgage]);

  return (
    <>
      <Box className="appear-anim">
        <IconTitle
          icon={
            <ThemedAsset
              id={assetIds.ICON_ID_LOCATION}
              width={ICON_TITLE_HEIGHT}
              height={ICON_TITLE_HEIGHT}
              style={{ color: palette.secondary.main }}
            />
          }
          title={<Text tId="ADDITIONAL_INFORMATION" />}
          subtitle={<Text tId="HOME_INFO" />}
        />
        <FormControl fullWidth>
          <InputLabel id="propertyType">
            <Text tId="PROPERTY_TYPE" />
          </InputLabel>
          <Controller
            name="propertyType"
            control={control}
            rules={{
              required: {
                value: true,
                message: <Text tId={"REQUIRED_FIELD"} />,
              },
            }}
            render={(props) => (
              <>
                <Select
                  MenuProps={{
                    MenuListProps: {
                      "aria-label": "Select main residence property type",
                    },
                  }}
                  onChange={(e) => props.onChange(e.target.value)}
                  value={props.value}
                  error={errors.addressType ? true : false}
                >
                  {objectTypesConfigToArray(
                    disableOthers === true
                      ? residencePropertyTypesWithoutOthersConfig
                      : residencePropertyTypesConfig
                  ).map((type) => (
                    <MenuItem key={type.value} value={type.value}>
                      {type.display}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText style={{ color: palette.error.main }}>
                  {errors.propertyType?.message}
                </FormHelperText>
              </>
            )}
          />
        </FormControl>

        <Controller
          name="mortgage"
          value={mortgage}
          control={control}
          render={(props) => (
            <>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={props.checked || mortgage}
                    onChange={(e) => props.onChange(e.target.checked)}
                    name="mortgage"
                    id="mortgage"
                    style={{
                      color: palette.text.title,
                    }}
                  />
                }
                label={
                  <Typography variant="caption">
                    <Text tId="MORTGAGE" />
                  </Typography>
                }
                style={{ width: "100%", margin: "0.25rem 0" }}
              />
            </>
          )}
        />
        <RichTextfield
          defaultValue={parseStringAmountWithUnitToNumber(
            data?.homeExpensesAmount
          )}
          allowDecimals
          hideIcon
          unitName={"€"}
          fullWidth
          disabled={!mortgage}
          label={
            <>
              <Text tId={"HOME_EXPENSES_AMOUNT"} />{" "}
              <Typography variant="caption">
                <Text tId={"YOUR_PART"} />
              </Typography>
            </>
          }
          type="text"
          id="homeExpensesAmount"
          name="homeExpensesAmount"
          InputLabelProps={{ shrink: true }}
          inputProps={{
            ref: register({
              required: {
                value: !!mortgage,
                message: <Text tId={"REQUIRED_FIELD"} />,
              },
              validate: {
                validate: (value) =>
                  validateMinimumMortgageValueAndReturnMessage(value),
              },
            }),
          }}
          error={errors.homeExpensesAmount ? true : false}
          helperText={errors.homeExpensesAmount?.message}
        />
        <InfoPanel infoData={infoDataPropertyTypeForm} />
      </Box>
      <Box>
        <MainButton onClick={handleSubmit(() => onSubmitForm(getValues()))} />
      </Box>
    </>
  );
}
